module.exports = __webpack_public_path__ + "static/media/1POLICY27.bba4fcb1.jpg";